// The new site header on top of the logged-in app (RouteWithSidebar in
// src/Pages/index.js). Replaces the old fixed `dashboard_header` (UserHeader);
// the sidebar and the page content stay as they are (see styles/app-restyle.css).
import React from "react";
import { SiteHeader } from "../components/site-header";
import { useRevampShellSetup } from "./RevampShell";

export default function AppHeader() {
  useRevampShellSetup();
  return (
    // vl-header-sticky (app.css): the wrapper itself must stick — QA row 23
    <div className="vl-revamp vl-header-sticky bg-background text-foreground antialiased">
      <SiteHeader />
    </div>
  );
}
